<template>
  <div
    v-if="canViewFormulations && hasResults"
    class="mt6 ce-productDetails-formulationsList">
    <h2 class="ce-productDetailsHeadline">
      {{ $t('productDetail.formulationsList.headline') }}
    </h2>

    <h3 class="ce-productDetailsSubHeadline">
      <i18n
        path="productDetail.formulationsList.excerptHint.content"
        tag="span">
        <a :href="searchLink">{{ $t('productDetail.formulationsList.excerptHint.cta') }}</a>
      </i18n>
    </h3>

    <div class="ce-productDataTable">
      <table>
        <tr>
          <th>
            {{ $t('productDetail.formulationsList.columns.shade') }}
          </th>
          <th>
            {{ $t('productDetail.formulationsList.columns.formulation') }}
          </th>
        </tr>
        <FormulationsListRow
          v-for="(formulation, index) in results"
          :key="formulation.id"
          :style="(index + 1) % 2 ? 'background: ' + tableBgColor : ''"
          :row="formulation" />
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FormulationRepositoryService from 'services/FormulationRepositoryService';
import FormulationsListRow from 'components/product-detail/FormulationsListRow.vue';

export default {
  components: { FormulationsListRow },
  props: {
    tableBgColor: {
      type: String,
      required: false,
      default: '#ebebeb'
    }
  },
  data() {
    return {
      results: null,
    };
  },
  mounted() {
    if (this.canViewFormulations) {
      this.fetchResults();
    }
  },
  watch: {
    activeIndustry() {
      this.results = null;
      this.fetchResults();
    }
  },
  computed: {
    ...mapState(['pigment', 'activeIndustry']),
    ...mapState('user', ['activeUser']),
    ...mapGetters('user', ['token', 'canViewFormulations']),
    ...mapState('generic', ['links']),
    hasResults() {
      return this.results && Array.isArray(this.results) && this.results.length > 0;
    },
    searchLink() {
      return `${this.links.formulationRepositoryPage}?i=${this.activeIndustry}&ingredient=${encodeURIComponent(this.pigment.prd)}`;
    },
  },
  methods: {
    async fetchResults() {
      this.results = await FormulationRepositoryService.getSuggestionsByProduct(this.pigment.id, this.activeIndustry, this.token);
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base.less';

.ce-productDetails-formulationsList {
  .ce-formulationsList-showMoreHint {
    .ms(-1);
    margin-top: @space-2;
  }

  .ce-productDataTable {
    th:first-child {
      // default td/th padding + color badge width + color badge margin right
      padding-left: (@space-2 + 20px + @space-2);
    }
  }
}
</style>
